<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (!isEnabled()) {
  <p-text size="sm" class="me-static-xs inline-block" aria-hidden="true">{{ timerLabel() }}</p-text>
  <span class="sr-only" aria-live="polite">{{ announcement() }}</span>
}
@if (isEnabled()) {
  <p-button-pure
    type="button"
    [underline]="true"
    [icon]="'none'"
    [disabled]="inactiveTimerButton"
    class="me-static-xs inline-block"
    (click)="clickHandler()"
  >
    {{ requestCodeTimerLabel }}
  </p-button-pure>
}
